import axios from "axios";
import serialize from "form-serialize";
import 'promise-polyfill/src/polyfill';
import './polyfills';

const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

function setPayment() {
  let hiddenPaymentInput = document.getElementById("paymentMethod")
  if(hiddenPaymentInput) {
    hiddenPaymentInput.value = this.value;
  }
}

const supportForm = document.getElementById("supportForm");

if (supportForm) {
  // Constants
  const apiUrl = "/api/fastgiver.php";
  const submitButtons = supportForm.querySelectorAll('button[type="submit"]');
  const statusMessage = supportForm.querySelector(
    ".support-form__status-message"
    );
    const loader = supportForm.querySelector(".support-form__loader");
    
    // Event handler
    supportForm.addEventListener("submit", handleSubmit);
    // Fix for Safari
    submitButtons.forEach(button => {
      button.addEventListener("click", setPayment)
    })
    
    // Handle form submit
    function handleSubmit(e) {
      e.preventDefault();
      e.stopPropagation();
      
      let action;
      if(isSafari == true) {
        let hiddenPaymentInput = document.getElementById("paymentMethod")
        action = hiddenPaymentInput.value;
    } else {
      action = e.submitter.value
    }
    
    // Lock form and show status
    submitButtons.forEach(submitButton => {
      submitButton.disabled = true;
      submitButton.style.cursor = "wait";
    });
    
    document.body.style.cursor = "wait";
    statusMessage.classList.add("fadein");
    loader.style.display = "inline-block";

    // const {action} = e.submitter.dataset;
    
    // Get form data and serialize (needed to send through js/ajax)
    const requestBody = `action=${action}&${serialize(supportForm)}`;
    // Send and handle request to API
    axios
      .post(apiUrl, requestBody)
      .then(function(response) {
        if (response.status === 200 && response.data.data.url) {
          handleFormSuccess(response.data.data.url);
        } else {
          handleFormError(response);
        }
      })
      .catch(function(response) {
        console.log("error", response)
        handleFormError(response);
      });
  };

  // Everything works - forward the user to a Thank you-page, with AvtaleGiro sign-link as POST data
  function handleFormSuccess(selfSignUrl) {
    // Unlock form in case the user go back later and want to submit again...
    submitButtons.forEach(submitButton => submitButton.disabled = false);
    document.body.style.cursor = "auto";
    statusMessage.classList.remove("fadein");
    loader.style.display = "none";

    window.location.href = selfSignUrl;
  }

  // Handle errors when submitting form
  function handleFormError(response) {
    console &&
      console.log &&
      console.log("Noe gikk galt. Vis feilmelding i skjema", response);

    // Unlock form so the user can try again

    submitButtons.forEach(submitButton => {

      submitButton.disabled = false;
      submitButton.style.cursor = "auto";

    });
    statusMessage.classList.add("fadein");
    statusMessage.innerHTML =
      "Noe gikk dessverre galt! <br> Vennligst kontakt oss hvis problemet vedvarer.";
    loader.style.display = "none";
  }
}
